/* ============================================================
   RPNT · extra
   1. Altura de la cabecera (--cab-h)
   2. Flecha al pie de pagina
   3. Bolsa como ventana (cajon)
   4. Ventanas desplegables de la cabecera (menu y busqueda)
   ============================================================ */
(function () {
  'use strict';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* 1. cabecera */
  function medirCab() {
    var c = $('.shopify-section-group-cabecera-grupo');
    var h = c ? c.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--cab-h', Math.round(h) + 'px');
  }
  medirCab();
  window.addEventListener('resize', medirCab);
  window.addEventListener('load', medirCab);
  setTimeout(medirCab, 300);

  /* 2. flecha al pie */
  function flecha() {
    var b = $('[data-flecha-pie]');
    var pie = $('.shopify-section-group-pie-grupo');
    if (!b || !pie) return;
    var muestra = /plantilla-(index|list-collections|product)\b/.test(document.body.className);
    if (!muestra) { b.hidden = true; return; }
    b.hidden = false;
    var arriba = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { arriba = e.isIntersecting; b.setAttribute('data-arriba', String(arriba)); });
      }, { threshold: 0.2 }).observe(pie);
    }
    function deslizar(destino) {
      var inicio = window.scrollY || document.documentElement.scrollTop;
      var delta = destino - inicio;
      var t0 = null, dur = 650;
      if (Math.abs(delta) < 2) return;
      function paso(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        window.scrollTo(0, inicio + delta * e);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    b.addEventListener('click', function () {
      if (arriba) { deslizar(0); }
      else { deslizar(pie.getBoundingClientRect().top + (window.scrollY || document.documentElement.scrollTop)); }
    });
  }

  /* 3. bolsa */
  function cajon() { return $('[data-cajon]'); }
  function contar(n) {
    $$('[data-bolsa-cuenta]').forEach(function (el) { el.textContent = n > 0 ? String(n) : ''; });
  }
  function abrir() {
    var c = cajon(); if (!c) return;
    c.setAttribute('data-abierto', 'true');
    c.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var x = $('.cajon__cerrar', c); if (x) x.focus({ preventScroll: true });
  }
  function cerrar() {
    var c = cajon(); if (!c) return;
    c.setAttribute('data-abierto', 'false');
    c.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function refrescar() {
    var c = cajon(); if (!c) return Promise.resolve();
    var abierto = c.getAttribute('data-abierto') === 'true';
    var raiz = (window.RPNT && window.RPNT.rutas && window.RPNT.rutas.raiz) || '/';
    return fetch(raiz + (raiz.indexOf('?') > -1 ? '&' : '?') + 'sections=carrito-cajon', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['carrito-cajon']; if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var nuevo = tmp.querySelector('[data-cajon]');
        var viejo = cajon();
        if (nuevo && viejo) { viejo.replaceWith(nuevo); }
        var n = Number((cajon() && cajon().getAttribute('data-cantidad')) || 0);
        contar(n);
        if (abierto) abrir();
      })
      .catch(function () {});
  }
  function post(url, cuerpo) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo) })
      .then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
  }
  function agregar(id, cantidad) {
    return post('/cart/add.js', { items: [{ id: Number(id), quantity: cantidad || 1 }] })
      .then(refrescar).then(abrir);
  }
  function actualizar() {
    var c = cajon(); if (!c) return;
    var cambios = {};
    $$('[data-cant]', c).forEach(function (i) { cambios[i.getAttribute('data-id')] = Math.max(0, parseInt(i.value, 10) || 0); });
    var b = $('[data-cajon-actualizar]', c); if (b) b.disabled = true;
    post('/cart/update.js', { updates: cambios }).then(refrescar).catch(refrescar);
  }
  function quitar(clave) {
    post('/cart/change.js', { id: String(clave), quantity: 0 }).then(refrescar).catch(refrescar);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-abrir-bolsa]')) { e.preventDefault(); e.stopPropagation(); cerrarPaneles(); refrescar().then(abrir); return; }
    if (t.closest('[data-cajon-cerrar]')) { e.preventDefault(); e.stopPropagation(); cerrar(); return; }
    if (t.closest('[data-cajon-actualizar]')) { e.preventDefault(); e.stopPropagation(); actualizar(); return; }
    var q = t.closest('[data-quitar]');
    if (q) { e.preventDefault(); e.stopPropagation(); quitar(q.getAttribute('data-quitar')); return; }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-cant]')) { e.preventDefault(); actualizar(); }
  });

  /* 4. ventanas desplegables: menu y busqueda cuelgan de la esquina de los iconos */
  var cerrarPaneles = function () {};
  function paneles() {
    var botones = $$('[data-panel-abrir]');
    var lista = $$('[data-panel]');
    if (!botones.length || !lista.length) return;
    function cerrarTodo() {
      lista.forEach(function (p) { p.setAttribute('data-abierto', 'false'); p.setAttribute('aria-hidden', 'true'); });
      botones.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    cerrarPaneles = cerrarTodo;
    function abrirPanel(nombre) {
      var p = lista.filter(function (x) { return x.getAttribute('data-panel') === nombre; })[0];
      if (!p) return;
      var estaba = p.getAttribute('data-abierto') === 'true';
      cerrarTodo();
      if (estaba) return;
      cerrar();                                   // la bolsa, si estaba abierta
      p.setAttribute('data-abierto', 'true');
      p.setAttribute('aria-hidden', 'false');
      botones.forEach(function (b) { if (b.getAttribute('data-panel-abrir') === nombre) b.setAttribute('aria-expanded', 'true'); });
      var campo = p.querySelector('[data-buscar-campo]');
      if (campo) setTimeout(function () { campo.focus({ preventScroll: true }); campo.select(); }, 90);
    }
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      var b = t.closest('[data-panel-abrir]');
      if (b) { e.preventDefault(); abrirPanel(b.getAttribute('data-panel-abrir')); return; }
      if (t.closest('[data-panel]')) return;
      cerrarTodo();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarTodo(); });
    window.RPNT = window.RPNT || {};
    window.RPNT.paneles = { abrir: abrirPanel, cerrar: cerrarTodo };
  }

  /* la busqueda va mostrando resultados mientras se escribe */
  function buscador() {
    var campo = $('[data-buscar-campo]');
    var caja = $('[data-buscar-resultados]');
    if (!campo || !caja) return;
    var raiz = (window.RPNT && window.RPNT.rutas && window.RPNT.rutas.raiz) || '/';
    var base = raiz.replace(/\/$/, '');
    var formato = (window.RPNT && window.RPNT.formatoDinero) || '${{amount}}';
    var reloj = null, control = null, ultima = '';
    function esc(x) { return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function precio(p) { return formato.replace(/<[^>]*>/g, '').replace(/\{\{\s*\w+\s*\}\}/, p); }
    function miniatura(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120'; }
    function pintar(q, datos) {
      var prods = (datos && datos.resources && datos.resources.results && datos.resources.results.products) || [];
      var html = '';
      if (!prods.length) {
        html = '<p class="desple__nada">' + esc(caja.getAttribute('data-txt-nada')) + '</p>';
      } else {
        html = prods.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var partes = String(p.title || '').split(' · ');
          var nombre = partes.length >= 2 ? partes[1] : p.title;
          var meta = partes.length >= 2 ? partes[0] + (partes[2] ? ' · ' + partes[2] : '') : (p.type || '');
          return '<a class="desple__res" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(miniatura(img)) + '" alt="" loading="lazy">' : '<span class="desple__res-vacio"></span>') +
            '<span><span class="desple__res-nombre">' + esc(nombre) + '</span><span class="desple__res-meta">' + esc(meta) + '</span></span>' +
            '<span class="desple__res-precio">' + esc(precio(p.price)) + '</span></a>';
        }).join('');
        html += '<a class="desple__todo" href="' + esc(caja.getAttribute('data-url') || (base + '/search')) + '?q=' + encodeURIComponent(q) + '">' + esc(caja.getAttribute('data-txt-todos')) + ' &rarr;</a>';
      }
      caja.innerHTML = html;
      caja.hidden = false;
    }
    function buscar() {
      var q = campo.value.trim();
      if (q === ultima) return;
      ultima = q;
      if (q.length < 2) { caja.hidden = true; caja.innerHTML = ''; return; }
      if (control && control.abort) control.abort();
      control = ('AbortController' in window) ? new AbortController() : null;
      var url = base + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url, { headers: { Accept: 'application/json' }, signal: control ? control.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (campo.value.trim() === q) pintar(q, j); })
        .catch(function () {});
    }
    campo.addEventListener('input', function () { clearTimeout(reloj); reloj = setTimeout(buscar, 220); });
  }

  window.RPNT = window.RPNT || {};
  window.RPNT.bolsa = { abrir: abrir, cerrar: cerrar, refrescar: refrescar, agregar: agregar, contar: contar };

  function arrancarExtra() { flecha(); paneles(); buscador(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancarExtra);
  else arrancarExtra();
  document.addEventListener('shopify:section:load', function () { medirCab(); });
})();
